import { BKJAvatar } from '@awais4123/fillify-design-library';
import { Flex } from 'components/Flex';
import {
  MemberComponentWrapper,
  MemberColumn,
  MemberRow,
  MemberTable,
  NoResultsWrapper,
} from 'pages/SettingsPage/modals/GroupsModal/views/static/MemberTable.component.styled';
import { IconButton } from 'components/IconButton';
import { FC, useMemo } from 'react';
import { ChangeEventType } from '@awais4123/fillify-design-library/lib/common.types';
import { useGroupsModalFormContext } from 'pages/SettingsPage/modals/GroupsModal/GroupsModal.form.context';
import { Jane } from 'types/graphql';
import { useTranslation } from 'hooks/useTranslation';
import { StyledBKJIcon } from 'components/JaneGridSelect/JaneGridSelect.styled';

export interface IMemberTableComponentProps {
  readOnly?: boolean;
  memberFilter?: string;
}

function applyStringTransformations(str: string) {
  return str.toLocaleLowerCase().replace(/\s+/g, '');
}

function filterMembers(members: Jane[], memberFilter?: string): Jane[] {
  return members.filter((member) => {
    if (memberFilter) {
      return applyStringTransformations(member.firstName + member.lastName).includes(
        applyStringTransformations(memberFilter),
      );
    }
    return true;
  });
}

export const MemberTableComponent: FC<IMemberTableComponentProps> = ({
  readOnly,
  memberFilter,
}: IMemberTableComponentProps) => {
  const { formMembers: members, deleteMember } = useGroupsModalFormContext();
  const filteredMembers = useMemo(
    () => filterMembers(members, memberFilter),
    [memberFilter, members],
  );
  const { t } = useTranslation();
  return (
    <MemberComponentWrapper>
      {filteredMembers.length === 0 && readOnly && (
        <Flex justifyContent="center" alignItems="center" height="100%">
          <NoResultsWrapper>{t('groups:NO_RESULTS')}</NoResultsWrapper>
        </Flex>
      )}
      {filteredMembers.length > 0 && (
        <MemberTable>
          {filteredMembers.map((member, i) => {
            return (
              <MemberRow key={i}>
                <MemberColumn>
                  <BKJAvatar
                    width="30px"
                    height="30px"
                    fallbackAvatarColor="Grey3"
                    src={member?.avatarUrls?.small}
                  />
                  {member?.pendingSignup && (
                    <StyledBKJIcon iconName="PendingSignup" left="17" top="16" width="20" />
                  )}
                  <Flex
                    alignItems="center"
                    width="80%"
                  >{`${member.firstName} ${member.lastName}`}</Flex>
                  <Flex alignItems="flex-end">
                    {!readOnly && (
                      <IconButton
                        iconName="CloseBold"
                        onClick={(e: ChangeEventType) => {
                          e.preventDefault();
                          deleteMember(member.id);
                        }}
                      />
                    )}
                  </Flex>
                </MemberColumn>
              </MemberRow>
            );
          })}
        </MemberTable>
      )}
    </MemberComponentWrapper>
  );
};
